import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { ISiteSettingsForServerAdmin } from '../../../settings/types/ISite';

export interface IGetSitesParams extends IGetItemsParams {
}

export interface IGetSitesResult extends IGetItemsResult {
  sites: ISiteSettingsForServerAdmin[];
}

export class GetSitesRequest extends Request<IGetSitesParams, IGetSitesResult> {
  constructor(params: IGetSitesParams) {
    super('getSites', params);
  }
}
